import { Link } from "react-router-dom";

const Footer = ({ brand = "split" }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#262626] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brandify Section */}
          <div>
            <h3 className="heading-font text-2xl text-[#1cb5ae] mb-4">BRANDIFY OFFICIAL</h3>
            <p className="text-sm text-gray-400 mb-4 brandify-body">
              AI-Driven Marketing, Tech Development & Growth Solutions
            </p>
            <div className="flex flex-col gap-2">
              <Link to="/brandify/services" className="text-sm text-gray-300 hover:text-[#1cb5ae] transition-colors" data-testid="footer-brandify-services">
                Services
              </Link>
              <Link to="/brandify/case-studies" className="text-sm text-gray-300 hover:text-[#1cb5ae] transition-colors" data-testid="footer-brandify-case-studies">
                Case Studies
              </Link>
              <Link to="/brandify/contact" className="text-sm text-gray-300 hover:text-[#1cb5ae] transition-colors" data-testid="footer-brandify-contact">
                Contact
              </Link>
            </div>
          </div>

          {/* Studio Section */}
          <div>
            <h3 className="heading-font text-2xl text-[#F97316] mb-4">WAKE N' BAKE STUDIO</h3>
            <p className="text-sm text-gray-400 mb-4 studio-body">
              Cinematic Production, Visual Storytelling & Brand Films
            </p>
            <div className="flex flex-col gap-2">
              <Link to="/studio/services" className="text-sm text-gray-300 hover:text-[#F97316] transition-colors" data-testid="footer-studio-services">
                Services
              </Link>
              <Link to="/studio/portfolio" className="text-sm text-gray-300 hover:text-[#F97316] transition-colors" data-testid="footer-studio-portfolio">
                Portfolio
              </Link>
              <Link to="/studio/contact" className="text-sm text-gray-300 hover:text-[#F97316] transition-colors" data-testid="footer-studio-contact">
                Contact
              </Link>
            </div>
          </div>

          {/* Admin & Info */}
          <div>
            <h3 className="heading-font text-2xl text-white mb-4">CONNECT</h3>
            <div className="flex flex-col gap-2">
              <Link to="/admin/login" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-admin-login">
                Admin Login
              </Link>
              <a href="mailto:hello@brandifyofficial.com" className="text-sm text-gray-300 hover:text-white transition-colors">
                hello@brandifyofficial.com
              </a>
              <a href="mailto:studio@wakenbake.com" className="text-sm text-gray-300 hover:text-white transition-colors">
                studio@wakenbake.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#262626] pt-8 text-center">
          <p className="text-sm text-gray-500">
            © {currentYear} Brandify Official × Wake N' Bake Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;